import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What is a VPN and how does it work?',
      answer: 'A VPN (Virtual Private Network) creates a secure, encrypted tunnel between your device and the internet. It masks your IP address and encrypts all your data, making it impossible for anyone to track your online activities or steal your personal information.'
    },
    {
      question: 'Is your VPN service secure?',
      answer: 'Absolutely. We use military-grade AES 256-bit encryption, the same standard used by governments and financial institutions worldwide. Combined with our strict no-logs policy and advanced security protocols, your data remains completely private and secure.'
    },
    {
      question: 'How many devices can I connect?',
      answer: 'Our VPN service supports multiple simultaneous connections on various devices including Windows, Mac, iOS, Android, Linux, and browser extensions. You can protect all your devices with a single account.'
    },
    {
      question: 'Do you keep logs of my activity?',
      answer: 'No, we maintain a strict zero-logs policy. We do not track, collect, or store any information about your browsing history, connection logs, IP addresses, or any other personal data. Your privacy is our top priority.'
    },
    {
      question: 'What countries do you have servers in?',
      answer: 'We operate a global network of high-speed servers in over 50 countries across North America, Europe, Asia, South America, and Oceania. This ensures you can always find a fast, reliable connection wherever you are.'
    },
    {
      question: 'How fast is the connection?',
      answer: 'Our VPN is optimized for speed with unlimited bandwidth. You can stream HD content, download large files, and browse without any noticeable slowdown. We continuously upgrade our infrastructure to provide the fastest possible speeds.'
    },
    {
      question: 'What encryption do you use?',
      answer: 'We use AES 256-bit encryption, which is the industry standard for data security. This military-grade encryption is virtually unbreakable and ensures that your data remains completely secure from hackers, ISPs, and government surveillance.'
    },
    {
      question: 'How do I get started?',
      answer: 'Getting started is easy! Simply contact us through the form above or reach out via email or phone. Our team will guide you through the setup process and help you secure your internet connection in minutes.'
    }
  ];

  return (
    <section id="faq" className="bg-white py-28">
      <div className="max-w-5xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-6 px-5 py-2 bg-[#00D9FF] rounded-full">
            <span className="text-white text-xs font-semibold uppercase tracking-wider whitespace-nowrap">FAQ</span>
          </div>
          <h2 className="text-5xl font-bold text-[#0A1628] mb-4">Frequently Asked Questions</h2>
          <p className="text-[#5A6B7F] text-lg">Everything you need to know about our VPN service</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`border border-[#E5E7EB] rounded-2xl transition-all duration-300 ${
                openIndex === index ? 'bg-[#F0FDFF] border-l-4 border-l-[#00D9FF]' : 'bg-white hover:bg-[#F0FDFF]'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left cursor-pointer"
              >
                <span className="text-[#0A1628] text-lg font-bold pr-4">{faq.question}</span>
                <i className={`${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'} text-[#00D9FF] text-2xl flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-8 pb-6 pt-2">
                  <p className="text-[#5A6B7F] text-base leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
